import { FC, useRef } from "react";
import { IAsset } from "../../models";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

export const CodeGenerator: FC<ICodeGenerator> = (data) => {
  const navigate = useNavigate();

  const generator = useRef(null);
  const print = useReactToPrint({
    contentRef: generator,
    documentTitle: data.item.description.replace(" ", "-"),
  });

  const onCreatePost = () => {
    if (!data.item) return;
    if (data.onClose) data.onClose();
    navigate(`/posts/create`, { state: { asset: data.item } });
  };

  return (
    <div ref={generator} className="bg-white rounded-lg mx-auto px-5 py-8">
      <div className="flex flex-col space-y-5 justify-center items-center text-center">
        <img src="/img/logo_foundat_alt.svg" alt="logo" className="w-1/2" />
        <div className="flex flex-col justify-center items-center">
          <p>
            <strong>Mobile Asset</strong>
          </p>
          <p>{data.item.description}</p>
        </div>
        <QRCode
          size={256}
          value={`{https://www.foundat.com/app,"ast":${data.item.number},"la":0,"lo":0,"a":0,"h":0}`}
          viewBox={`0 0 256 256`}
          className="w-3/5"
        />
        <small>Number: {data.item.number}</small>
        <div className="flex flex-row space-x-3 justify-center items-center">
          <button
            type="button"
            className="border rounded font-medium px-3 py-2 text-sm text-slate-500 hover:bg-logo hover:text-white print:hidden"
            onClick={() => print()}
          >
            Print to PDF
          </button>
          <button
            type="button"
            className="border rounded font-medium px-3 py-2 text-sm text-slate-500 hover:bg-logo hover:text-white print:hidden"
            onClick={() => onCreatePost()}
          >
            Create Post
          </button>
        </div>
      </div>
    </div>
  );
};

interface ICodeGenerator {
  item: IAsset;
  onClose?: () => void;
}
